import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Image1 from "../static/Page_1.jpg";
import Image2 from "../static/Page_2.jpg";
import "./HeritageSection.css";

export default function HeritageSection() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section className="heritage-section" ref={sectionRef}>
      <div className="heritage-container">
        {/* Left - Images */}
        <div className={`heritage-images ${isVisible ? "visible" : ""}`}>
          <div className="image-main">
            <img src={Image2} alt="Polania craftsman at work" />
            <div className="image-frame"></div>
          </div>
          <div className="image-secondary">
            <img src={Image1} alt="Polania heritage" />
          </div>
          <div className="experience-badge">
            <span className="badge-number">40+</span>
            <span className="badge-text">YEARS</span>
          </div>
        </div>

        {/* Right - Content */}
        <div className={`heritage-content ${isVisible ? "visible" : ""}`}>
          <span className="section-label">OUR HERITAGE</span>
          <h2 className="heritage-title">
            POLISH MASONRY
            <br />
            <span className="gold-text">PERFECTED IN AMERICA</span>
          </h2>
          
          <div className="heritage-text">
            <p>
              Since 1985, Polania Construction has been the premier choice for 
              custom masonry in Central New Jersey. What began as a partnership 
              between Polish master craftsmen Paul Banasik and Jack Marchwinski 
              has evolved into a legacy of excellence.
            </p>
            <p>
              In 2021, the torch was passed to a new generation—Adrian Wasilewski 
              and Jerzy Murdzek—who continue the tradition of bringing authentic 
              Polish masonry techniques to American homes and businesses.
            </p>
          </div>

          <div className="heritage-features">
            <div className="feature-item">
              <div className="feature-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                </svg>
              </div>
              <div className="feature-text">
                <h4>Licensed & Insured</h4>
                <p>NJ License #13VH12000800</p>
              </div>
            </div>
            <div className="feature-item">
              <div className="feature-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                </svg>
              </div>
              <div className="feature-text">
                <h4>Family Owned</h4>
                <p>Two generations of excellence</p>
              </div>
            </div>
            <div className="feature-item">
              <div className="feature-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                </svg>
              </div>
              <div className="feature-text">
                <h4>100% Satisfaction</h4>
                <p>Quality guaranteed on every project</p>
              </div>
            </div>
          </div>

          <Link to="/about" className="btn-outline heritage-cta">
            LEARN OUR STORY
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
}
